<template>
  <div>
    <div v-show="!editing">
      {{value}}
      <span @click="editing=true">
        <img alt="Edit" src="../assets/edit-16.png" />
      </span>
    </div>
    <div class="inputflex" v-show="editing">
      <b-form-input
        v-model="valueComputed"
        @keydown.enter="communicateModification"
        class="form-control textbox"
      />
      <span>
        <img alt="Save" src="../assets/checkmark-16.png" @click="communicateModification" />
        <img alt="Save" src="../assets/cancel-16.png" @click="cancelModification" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditableText",
  props: { value: null, parentid: null },
  data() {
    return {
      editing: false,
      valueData: "",
    };
  },
  computed: {
    valueComputed: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.valueData = val;
      },
    },
  },
  methods: {
    cancelModification() {
      this.editing = false;
      this.valueData = this.value;
    },
    communicateModification() {
      this.editing = false;
      if (this.valueData !== "") {
        this.$emit("modified", this.parentid, this.valueData);
      } else {
        this.cancelModification();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.textbox {
  /* float: left; */
  margin-right: 10px;
}

.inputflex {
  display: flex;
}
</style>